import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { externalLink } from '../../../../configs/externalLink'
import { Element } from '../../html/element'
import { getPercentDiscount } from './helper'
import classes from './index.module.scss'
import { selectData } from './store/slice'

export const HeaderForPreview = ({
  downloadSampleReport,
  isBlockCompanyType,
}) => {
  const data = useSelector(selectData)
  const locale = useSelector((state) => state.i18n.locale)

  const onClick = () => {
    window.open(externalLink.FACT_SHEET_SERVICE_DETAILS[locale], '__blank')
  }

  return (
    <Element style={{ backgroundColor: '#F3F3F3' }} className={classes.header}>
      <div className={classes.headerTitle}>
        <Element elementName="span" style={{ fontSize: 20 }} className="fw600">
          <Translate value="common.order.factSheet.FIINGATE_FACTSHEET" />
        </Element>
        {!isBlockCompanyType && (
          <Element
            elementName="span"
            style={{ color: '#2C73E8' }}
            className="fw400 cursorPointer"
            onClick={onClick}
          >
            <Translate value="domesticSearchPreview.SERVICE_DETAIL" />
          </Element>
        )}
      </div>
      {!isBlockCompanyType && (
        <div className="dFlex alignItemsCenter justifyContentBetween gap2">
          <div className="flexColumn">
            <Translate
              value="common.order.factSheet.PREVIEW_FACT_SHEET_DESC"
              dangerousHTML
            />
            <Translate
              value="common.order.factSheet.PREVIEW_FACT_SHEET_DESC_2"
              percent={getPercentDiscount(data, locale)}
              dangerousHTML
            />
          </div>
          <Element
            elementName="span"
            style={{ color: '#2C73E8', fontSize: 14 }}
            className="cursorPointer fw600 whiteSpaceNowrap"
            onClick={downloadSampleReport}
          >
            <Translate value="common.order.factSheet.SAMPLE_REPORT" />
          </Element>
        </div>
      )}
    </Element>
  )
}
